import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {Translate, translate} from 'views/module';

const ClientEditStatus = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldStatus = oldData.status;
  const newStatus = newData.status;

  return (
    <Stack>
      <Translate
        expression='client.ClientDetail.Correspondance.Logs.EditStatus.Text'
        substitute={{
          oldStatus: translate(`client.Status.${oldStatus}.Title`),
          newStatus: translate(`client.Status.${newStatus}.Title`),
        }}
      />
    </Stack>
  );
};
ClientEditStatus.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientEditStatus);
